import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { CSVLink } from "react-csv";
import _ from "lodash";
import ReactPaginate from "react-paginate";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function ChatGptList(props) {
    const [formData, setName] = useState({
        caseID: "",
        caseName: "",
        userName: "",
    });
    const [QuesList, setQuesList] = useState([]);
    const [QuesList2, setQuesList2] = useState([]);

    const [deberiefingData, setDeberiefingData] = useState({});
    const [deberiefing, setDeberiefing] = useState([]);
    const [deberiefingLogs, setDeberiefingLogs] = useState([]);

    const [disable, setDisable] = useState(true);
    const [todate, setTodatePic] = useState("");
    const [fromdate, setFromdatePic] = useState("");
    const [FrDate, setFrDate] = useState("");
    const [ToDate, setToDate] = useState("");
    const [todateformat, setTodateformat] = useState("");
    const [fromdateformat, setFromdateformat] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [paginatedPosts, setpaginatedPosts] = useState();
    const ManagerId = localStorage.getItem("ManegerId");
    const Role = localStorage.getItem("URole");
    let [loading, setLoading] = useState(true);
    let [isFetchingData, setIsFetchingData] = useState(true);

    const [Record, seRecord] = useState([]);

    const csvLink = useRef();
    let pageSize = 10;

    const navigate = useHistory();

    useEffect(() => {
        LoadGptList();
    }, [pageSize]);

    const LoadGptList = () => {
        setLoading(true);
        const datavalue = {
            ManagerId: Role == "Admin" ? 1 : ManagerId,
        };

        var authOptions = {
            method: "post",
            url: `${process.env.REACT_APP_API_URL}/GetDeberiefingListDesc`,
            data: datavalue,
            headers: { "Content-Type": "multipart/form-data" },
        };

        axios(authOptions)
            .then((res) => {
                seRecord(res.data.length);
                if (res.data.length > 10) {
                    setQuesList(res.data);

                    setpaginatedPosts(_(res.data).slice(0).take(pageSize).value());
                } else {
                    setQuesList2(res.data);
                }
            })
            .finally(() => setLoading(false));
    };

    const pageCount = QuesList ? Math.ceil(QuesList.length / pageSize) : 0;
    if (pageCount === 1) return null;
    const pages = _.range(1, pageCount + 1);

    const handlePageClick = async (data) => {
        let currentPage = data.selected + 1;
        setCurrentPage(currentPage);
        const startIndex = (currentPage - 1) * pageSize;
        const paginatedPost = _(QuesList).slice(startIndex).take(pageSize).value();
        setpaginatedPosts(paginatedPost);
    };

    const handlefromdate = (date) => {
        const getfromdatevalue = formatDate(date);

        setFromdatePic(date);

        const setfromformat = getfromdatevalue.split("-");
        const setfromyear = setfromformat[0];
        const setfrommonth = setfromformat[1];
        const setfromdate = setfromformat[2];
        const setfromformatdate =
            setfromyear + "" + setfrommonth + "" + setfromdate;
        setFrDate(getfromdatevalue);
        setFromdateformat(setfromformatdate);
        setDisable(false);
    };

    const handletodate = (date) => {

        const gettodatevalue = formatDate(date);
        setTodatePic(date);
        const setdateformat = gettodatevalue.split("-");
        const settoyear = setdateformat[0];
        const settomonth = setdateformat[1];
        const settodate = setdateformat[2];
        const settodateformat = settoyear + "" + settomonth + "" + settodate;
        setToDate(gettodatevalue);
        setTodateformat(settodateformat);
    };

    function formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        let formDataSet = new FormData();

        if (fromdateformat > todateformat) {
            alert("Please select valid date");
        } else {
            if (
                FrDate != "" ||
                ToDate != "" ||
                formData.caseID != "" ||
                formData.caseName != "" ||
                formData.userName != ""
            ) {
                formDataSet.append(
                    "fdate",
                    FrDate == null || FrDate == "" ? "" : FrDate
                );
                formDataSet.append(
                    "tdate",
                    ToDate == null || ToDate == "" ? "" : ToDate
                );
                formDataSet.append(
                    "UserName",
                    formData.userName == null || formData.userName == "" ? "" : formData.userName
                );
                formDataSet.append(
                    "CaseId",
                    formData.caseID == null || formData.caseID == "" ? "" : formData.caseID
                );
                formDataSet.append(
                    "CaseName",
                    formData.caseName == null || formData.caseName == "" ? "" : formData.caseName
                );
                formDataSet.append("ManagerId", Role == "Admin" ? 1 : ManagerId);

                var authOptions = {
                    method: "post",
                    url: `${process.env.REACT_APP_API_URL}/GetFilterDeberiefing`,
                    data: formDataSet,
                    headers: { "Content-Type": "multipart/form-data" },
                };

                axios(authOptions)
                    .then((res) => {
                        seRecord(res.data.length);
                        if (res.data.length > 10) {
                            setQuesList(res.data);
                            setpaginatedPosts(_(res.data).slice(0).take(pageSize).value());
                        } else {
                            setQuesList2(res.data);
                        }
                    })
                    .catch((error) => {
                    })
                    .finally(() => setLoading(false));
            } else {
                LoadGptList();
            }
        }
    };

    const viewDeberiefingDetails = (deberiefingData) => {
        setIsFetchingData(true);

        const datavalue = {
            deberiefingId: deberiefingData.id,
            sessionId: deberiefingData.session_Id,
        };

        var authOptions = {
            method: "post",
            url: `${process.env.REACT_APP_API_URL}/GetDeberiefingDetail`,
            data: datavalue,
            headers: { "Content-Type": "multipart/form-data" },
        };

        axios(authOptions)
            .then((res) => {
                setDeberiefing(res.data.deberiefingDetails);
                setDeberiefingLogs(res.data.chatLogs);
                setDeberiefingData(deberiefingData);

                setIsFetchingData(false);

                // var myModal = new bootstrap.Modal(document.getElementById("deberiefingLogsModal"));
                // myModal.show();

            })
            .catch((error) => {
                setIsFetchingData(false);

                //console.log("error occur", error);
            });
    }

    const headers = [
        "Case Id",
        "Case Name",
        "User Name",
        "Session Duration",
        "Session End Time",
    ];
    const csvData =
        Record > 10
            ? [
                headers,
                ...QuesList.map((item) => {
                    return [
                        item.case_Id,
                        item.case_Name,
                        item.user_Name,
                        item.duration,
                        item.session_End_Time,
                    ];
                }),
            ]
            : [
                headers,
                ...QuesList2.map((item) => {
                    return [
                        item.case_Id,
                        item.case_Name,
                        item.user_Name,
                        item.duration,
                        item.session_End_Time,
                    ];
                }),
            ];

    const handleChange = (e) => {
        setName({ ...formData, [e.target.name]: e.target.value });
    };

    const BackFunc = () => {
        navigate.push("/index");
    };

    return (
        <>
            <div className="page-content-wrapper">

                {/* Deberiefing Logs Modal */}
                <div class="modal fade" style={{ top: "30px", left: "25px" }} id="deberiefingLogsModal" tabindex="-1" aria-labelledby="deberiefingLogsModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-fullscreen" style={{ width: "98%", height: "95%" }}>
                        <div class="modal-content" style={{ paddingRight: "10px" }}>
                            <div class="modal-header pt-0">
                                <h5 class="modal-title" style={{ fontWeight: "600" }}>Debriefing Details</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body pt-0">
                                {deberiefingData &&
                                    <div className="table-responsive">
                                        <table className="table table-striped custom-table table-hover">
                                            <thead>
                                                <tr style={{background: "#6777ef", color: "#FFF"}}>
                                                    <th>Case ID</th>
                                                    <th width="25%">Case Name</th>
                                                    <th width="15%" className="text-center">User Name</th>
                                                    <th width="15%" className="text-center">Session Duration</th>
                                                    <th width="25%" className="text-center">Session End Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="text-left">
                                                        {deberiefingData.case_Id}
                                                    </td>

                                                    <td className="text-left">
                                                        {deberiefingData.case_Name}
                                                    </td>

                                                    <td className="text-center">
                                                        {deberiefingData.user_Name}
                                                    </td>

                                                    <td className="text-center">
                                                        {deberiefingData.duration}
                                                    </td>

                                                    <td className="text-center td-date">
                                                        {deberiefingData.session_End_Time}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                }
                                <hr style={{ height: "2px", background: "#711a1a73", marginTop: "0" }} />

                                {isFetchingData &&
                    <>
                      {/* Loading Animation Starts */}
                      <div className="col-sm-6 d-flex justify-content-center align-items-center" style={{ marginTop: "150px", marginLeft: "auto", marginRight: "auto" }}>
                        <div class="device" style={{ fontSize: "30px" }}>
                          <div class="device__a" style={{ backgroundColor: "#abafba" }}>
                            <div class="device__a-1" style={{ backgroundColor: "#000" }}></div>
                            <div class="device__a-2" style={{ backgroundColor: "#000" }}></div>
                          </div>
                          <div class="device__b" style={{ backgroundColor: "#000" }}></div>
                          <div class="device__c" style={{ backgroundColor: "#000" }}></div>
                          <div class="device__d" style={{ backgroundColor: "#abafba" }}></div>
                          <div class="device__e" style={{ backgroundColor: "#abafba" }}></div>
                          <div class="device__f" style={{ backgroundColor: "#abafba" }}></div>
                          <div class="device__g" style={{ backgroundColor: "#abafba" }}></div>
                        </div>
                      </div>
                      {/* Loading Animation Ends */}
                    </>
                  }
                                <div className="row">
                                    {!isFetchingData && deberiefing.length > 0 &&
                                        <div className="col-lg-6">
                                            <h5 className="text-center" style={{ fontWeight: "600", background: "#15bd8c", padding: "10px", marginTop: "50px" }}>Debriefing Details</h5>

                                            <div className="table-responsive">
                                                <table className="table table-striped custom-table table-hover">
                                                    <thead>
                                                        <tr style={{background: "#6777ef", color: "#FFF"}}>
                                                            <th width="30%">Skill Name</th>
                                                            <th width="55%">Feedback</th>
                                                            <th width="15%" className="text-center">Score</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {deberiefing.map((item, index) => (
                                                            <tr key={index}>
                                                                <td className="text-left">
                                                                    {item.skill_Name}
                                                                </td>

                                                                <td className="text-left">
                                                                    {item.skill_Description}
                                                                </td>

                                                                <td className="text-center">
                                                                    {item.skill_Score}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    }

                                    {!isFetchingData && deberiefingLogs.length > 0 &&
                                        <div className="col-lg-6">
                                            <h5 className="text-center" style={{ fontWeight: "600", background: "#15bd8c", padding: "10px", marginTop: "50px" }}>Conversation Logs</h5>

                                            <div className="table-responsive">
                                                <table className="table table-striped custom-table table-hover">
                                                    <thead>
                                                        <tr style={{background: "#6777ef", color: "#FFF"}}>
                                                            <th width="30%">Question</th>
                                                            <th width="30%">Response</th>
                                                            <th width="20%" className="text-center">Expression</th>
                                                            <th width="20%" className="text-center">Timestamp</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {deberiefingLogs.map((item, index) => (
                                                            <tr key={index}>
                                                                <td className="text-left">
                                                                    {item.question}
                                                                </td>

                                                                <td className="text-left">
                                                                    {JSON.parse(item.responces).response}
                                                                </td>

                                                                <td className="text-center">
                                                                    {JSON.parse(item.responces).emotion}
                                                                </td>

                                                                <td className="text-left">
                                                                    {item.timestamp}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" data-bs-dismiss="modal" class="btn btn-primary">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Deberiefing Logs Modal */}


                {loading ? (
                    <div className="page-content d-flex justify-content-center align-items-center">
                        <div className="my-wrapper">
                            <div class="spinner center">
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                                <div class="spinner-blade"></div>
                            </div>
                        </div>

                    </div>
                ) : (<></>)
                }
                <div className="page-content">
                    {loading ? (
                        <>
                            <div className="page-bar" style={{ display: "none" }}>
                                <div className="page-title-breadcrumb">
                                    <div className=" pull-left">
                                        <div className="page-title my-0">List of Sessions</div>
                                    </div>
                                </div>

                                <div className="page-title-breadcrumb">
                                    <div className=" pull-right">
                                        <button
                                            type="submit"
                                            className="btn d-inline-block btn-primary"
                                            onClick={BackFunc}
                                        >
                                            {" "}
                                            <i className="fa fa-arrow-left" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ display: "none" }}>
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group custom-form-padding">
                                        <div className="row gx-1">
                                            <div className="col-lg-12">
                                                <div className="form-group row gx-1">
                                                    <div className="col">
                                                        <label className="col-12 control-label">
                                                            User Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            onChange={handleChange}
                                                            name="userName"
                                                            className="form-control"
                                                            id="userName"
                                                            placeholder="Enter User Name"
                                                        />
                                                    </div>
                                                    <div className="col">
                                                        <label className="col-12 control-label">
                                                            Case Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            onChange={handleChange}
                                                            name="caseName"
                                                            className="form-control"
                                                            id="caseName"
                                                            placeholder="Enter Case Name"
                                                        />
                                                    </div>

                                                    <div className="col">
                                                        <label className="col-12 control-label">Case ID</label>
                                                        <input
                                                            type="number"
                                                            onChange={handleChange}
                                                            name="caseID"
                                                            className="form-control"
                                                            id="caseID"
                                                            placeholder="Enter Case ID"
                                                        />
                                                    </div>

                                                    <div className="col custom-datepicker">
                                                        <label className="col-12 control-label">
                                                            {" "}
                                                            From Date
                                                        </label>
                                                        <DatePicker
                                                            selected={fromdate}
                                                            onChange={handlefromdate}
                                                            dateFormat="MM/dd/yyyy"
                                                            placeholderText="mm/dd/yyyy"
                                                            className="form-control w-100"
                                                            name="fromdate"
                                                        />
                                                    </div>
                                                    <div className="col custom-datepicker">
                                                        <label className="col-12  control-label">To date</label>
                                                        <DatePicker
                                                            selected={todate}
                                                            onChange={handletodate}
                                                            dateFormat="MM/dd/yyyy"
                                                            placeholderText="mm/dd/yyyy"
                                                            className="form-control w-100"
                                                            name="todate"
                                                            disabled={disable}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="offset-md-3 col-md-9">
                                            <div className="col-12 text-end">
                                                <button
                                                    type="submit"
                                                    className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 me-2 btn btn-primary"
                                                >
                                                    Search
                                                </button>

                                                <CSVLink
                                                    data={csvData}
                                                    className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-success"
                                                    filename={"DeberiefingFile.csv"}
                                                    target="_blank"
                                                    style={{ color: "black" }}
                                                >
                                                    Export
                                                </CSVLink>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div></>
                    ) : (
                        <>
                            <div className="page-bar">
                                <div className="page-title-breadcrumb">
                                    <div className=" pull-left">
                                        <div className="page-title my-0">List of Sessions</div>
                                    </div>
                                </div>

                                <div className="page-title-breadcrumb">
                                    <div className=" pull-right">
                                        <button
                                            type="submit"
                                            className="btn d-inline-block btn-primary"
                                            onClick={BackFunc}
                                        >
                                            {" "}
                                            <i className="fa fa-arrow-left" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group custom-form-padding">
                                        <div className="row gx-1">
                                            <div className="col-lg-12">
                                                <div className="form-group row gx-1">
                                                    <div className="col">
                                                        <label className="col-12 control-label">
                                                            User Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            onChange={handleChange}
                                                            name="userName"
                                                            className="form-control"
                                                            id="userName"
                                                            placeholder="Enter User Name"
                                                        />
                                                    </div>
                                                    <div className="col">
                                                        <label className="col-12 control-label">
                                                            Case Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            onChange={handleChange}
                                                            name="caseName"
                                                            className="form-control"
                                                            id="caseName"
                                                            placeholder="Enter Case Name"
                                                        />
                                                    </div>

                                                    <div className="col">
                                                        <label className="col-12 control-label">Case ID</label>
                                                        <input
                                                            type="number"
                                                            onChange={handleChange}
                                                            name="caseID"
                                                            className="form-control"
                                                            id="caseID"
                                                            placeholder="Enter Case ID"
                                                        />
                                                    </div>

                                                    <div className="col custom-datepicker">
                                                        <label className="col-12 control-label">
                                                            {" "}
                                                            From Date
                                                        </label>
                                                        <DatePicker
                                                            selected={fromdate}
                                                            onChange={handlefromdate}
                                                            dateFormat="MM/dd/yyyy"
                                                            placeholderText="mm/dd/yyyy"
                                                            className="form-control w-100"
                                                            name="fromdate"
                                                        />
                                                    </div>
                                                    <div className="col custom-datepicker">
                                                        <label className="col-12  control-label">To date</label>
                                                        <DatePicker
                                                            selected={todate}
                                                            onChange={handletodate}
                                                            dateFormat="MM/dd/yyyy"
                                                            placeholderText="mm/dd/yyyy"
                                                            className="form-control w-100"
                                                            name="todate"
                                                            disabled={disable}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="offset-md-3 col-md-9">
                                            <div className="col-12 text-end">
                                                <button
                                                    type="submit"
                                                    className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 me-2 btn btn-primary"
                                                >
                                                    Search
                                                </button>

                                                <CSVLink
                                                    data={csvData}
                                                    className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-success"
                                                    filename={"DeberiefingFile.csv"}
                                                    target="_blank"
                                                    style={{ color: "black" }}
                                                >
                                                    Export
                                                </CSVLink>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-head">
                                                    <header>Session List</header>
                                                    <div className="tools">
                                                    </div>
                                                </div>
                                                <div className="card-body ">
                                                    <div className="table-responsive">
                                                        <table className="table table-striped custom-table table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th>Case ID</th>
                                                                    <th width="25%">Case Name</th>
                                                                    <th width="15%" className="text-center">User Name</th>
                                                                    <th width="15%" className="text-center">Session Duration</th>
                                                                    <th width="25%" className="text-center">Session End Time</th>
                                                                    <th className="text-center">Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {Record > 10
                                                                    ? paginatedPosts &&
                                                                    paginatedPosts.length > 0 &&
                                                                    paginatedPosts.map((item) => (
                                                                        <tr>
                                                                            <td className="text-left">
                                                                                {item.case_Id}
                                                                            </td>

                                                                            <td className="text-left">
                                                                                {item.case_Name}
                                                                            </td>

                                                                            <td className="text-center">
                                                                                {item.user_Name}
                                                                            </td>

                                                                            <td className="text-center">
                                                                                {item.duration}
                                                                            </td>

                                                                            <td className="text-center td-date">
                                                                                {item.session_End_Time}
                                                                            </td>

                                                                            <td className="text-center">
                                                                                <button
                                                                                    data-bs-toggle="modal" data-bs-target="#deberiefingLogsModal"
                                                                                    className="btn btn-primary"
                                                                                    style={{ padding: "5px" }}
                                                                                    onClick={() => {
                                                                                        viewDeberiefingDetails(item);
                                                                                    }}
                                                                                >
                                                                                    <i className="fa fa-eye" style={{ color: "#FFF" }}></i>
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                    : QuesList2 &&
                                                                    QuesList2.length > 0 &&
                                                                    QuesList2.map((item) => (
                                                                        <tr>
                                                                            <td className="text-left">
                                                                                {item.case_Id}
                                                                            </td>

                                                                            <td className="text-left">
                                                                                {item.case_Name}
                                                                            </td>

                                                                            <td className="text-center">
                                                                                {item.user_Name}
                                                                            </td>

                                                                            <td className="text-center">
                                                                                {item.duration}
                                                                            </td>

                                                                            <td className="text-center td-date">
                                                                                {item.session_End_Time}
                                                                            </td>

                                                                            <td className="text-center">
                                                                                <button
                                                                                    data-bs-toggle="modal" data-bs-target="#deberiefingLogsModal"
                                                                                    className="btn btn-primary"
                                                                                    style={{ padding: "5px" }}
                                                                                    onClick={() => {
                                                                                        viewDeberiefingDetails(item);
                                                                                    }}
                                                                                >
                                                                                    <i className="fa fa-eye" style={{ color: "#FFF" }}></i>
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    {Record > 10 ? (
                                                        <ReactPaginate
                                                            previousLabel={"Prev"}
                                                            nextLabel={"Next"}
                                                            breakLabel={"..."}
                                                            pageCount={pageCount}
                                                            marginPagesDisplayed={2}
                                                            pageRangeDisplayed={3}
                                                            onPageChange={handlePageClick}
                                                            containerClassName={
                                                                "pagination justify-content-center"
                                                            }
                                                            pageClassName={"page-item"}
                                                            pageLinkClassName={"page-link"}
                                                            activeClassName={"active"}
                                                            previousClassName={"page-item"}
                                                            nextClassName={"page-item"}
                                                            previousLinkClassName={"page-link"}
                                                            nextLinkClassName={"page-link"}
                                                        />
                                                    ) : (
                                                        <div></div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

export default ChatGptList;
